import React from "react";
import ReactMarkdown from "react-markdown";

const preamble = `# ARKit Face Blendshapes (Perfect Sync)

This website shows an example of each blendshape that ARKit uses to describe faces. This information can be useful when creating a 3d model you'd like to animate using ARKit; for instance, a model to be used with the "Perfect Sync" feature of [VMagicMirror](https://malaybaku.github.io/VMagicMirror/en/tips/perfect_sync) or [vear](https://apps.apple.com/jp/app/id1490697369).

## Useful links

- [ARFaceAnchor.BlendShapeLocation](https://developer.apple.com/documentation/arkit/arfaceanchor/blendshapelocation) documentation
  - This is where I got the images from.
- [iPhone トラッキング向け BlendShape リスト](https://hinzka.hatenablog.com/entry/2020/06/15/072929)
- [@hinzka/52blendshapes-for-VRoid-face](https://github.com/hinzka/52blendshapes-for-VRoid-face)
  - This repository contains modified versions of [VRoid Studio](https://vroid.com/en/studio) models with these blend shapes added, distributed in [VRM format](https://vrm.dev/en/). These models can be used as bases for your own VRoid Studio avatars, in order to enable Perfect Sync.
- [VMagicMirror Perfect Sync Tips](https://malaybaku.github.io/VMagicMirror/en/tips/perfect_sync)
- [iPhoneMoCapiOS](https://github.com/johnjcsmith/iPhoneMoCapiOS)
- [How to create Apple’s Animoji using ARKit?](https://medium.com/@ashutoshdingankar/how-to-create-apples-animoji-using-arkit-4691e04bfc42)
- [iPhone X Facial Capture - Apple blendshapes](http://blog.kiteandlightning.la/iphone-x-facial-capture-apple-blendshapes/)
  - This is where I got the 3d models from. I don't know where they originally got them.
- [クリックで実装！パーフェクトシンク　BY HANA Tool](https://hinzka.hatenablog.com/entry/2020/10/12/014540)
  - This tool will automatically create all the blendshapes for an avatar created with [VRoid](https://vroid.com/en/).

## Notes

- \`tongueOut\` is currently missing because I couldn't find an image or model for it.
- __If you can't see all of the 3D Models, try opening the website in Firefox instead.__
`;

export default function Preamble() {
  return (
    <div style={{ maxWidth: 800 }}>
      <ReactMarkdown source={preamble} />
    </div>
  );
}
